import { frontendURL } from 'dashboard/helper/URLHelper.js';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

import WhatsappCatalogsRouteView from './pages/WhatsappCatalogsRouteView.vue';
import WhatsappCatalogsInboxListPage from './pages/WhatsappCatalogsInboxListPage.vue';
import WhatsappCatalogSettingsPage from './pages/WhatsappCatalogSettingsPage.vue';

const meta = {
  featureFlag: FEATURE_FLAGS.WHATSAPP_TEMPLATE_BUILDER,
  permissions: ['administrator'],
};

const whatsappCatalogsRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/whatsapp-catalogs'),
      component: WhatsappCatalogsRouteView,
      children: [
        {
          path: '',
          name: 'whatsapp_catalogs_index',
          meta,
          component: WhatsappCatalogsInboxListPage,
        },
        {
          path: ':inboxId',
          name: 'whatsapp_catalogs_settings',
          meta,
          component: WhatsappCatalogSettingsPage,
        },
      ],
    },
  ],
};

export default whatsappCatalogsRoutes;
